import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  methods: {
    //获取单条数据
    getById(StockOutId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        Id: StockOutId,
      };
      this.loading = true;
      this.Form = [];
      $http.get("api/UserStockOut/GetUserStockOutById", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.Form = Data;
          this.OrderInfo = Data.OrderInfo
          this.SendInfo = Data.SendInfo
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Family/StockOut/ViewPage/services.js